import { CategoryChartQueryFn, CategoryChartQueryParam } from "../categoryChart";
import { getBaseValue, KpiReport } from "../processors";
import { getKpisForProvidersWithCategoryChart } from "../../Components/opendata";
import { EMPTY_ARRAY, getFigureAndSolidDashGraph } from "../../Components/misc";
import _ from "lodash";
import { FigureSolidDashKpiProvider } from "./categoryChartData.types";

// const defaultReport: KpiReport= {
//     kpiCode: null,
//     name: null,
//     schemeId: null,
//     schemeType: "WSP",
//     status: true,
//     tid: -1,
//     year
// }
export const getLostSuppliedVolumnPercent = (kpis: string[][], yearBasedResults: KpiReport[]): KpiReport => {
    if (!kpis || kpis?.length === 0 || !yearBasedResults || yearBasedResults?.length === 0) return {} as KpiReport;

    const numerKpi = kpis?.[0]?.[0];
    const denoKpis = kpis
        .filter((__, index) => index !== 0)
        .map(d => d?.[0])
        .filter(d => d != null);

    if (!numerKpi || !denoKpis) return {} as KpiReport;
    // const defaultReport: KpiReport = {
    //     ...(yearBasedResults?.[0] ?? {}),
    //     kpiCode: numerKpi,
    //     name: null,
    //     schemeId: null,
    //     schemeType: "WSP",
    //     status: true,
    //     value: 0,
    //     valueStatus: null,
    //     weight: -1,
    //     tid: -1,
    //     unit: "%",
    //     year
    // };

    const denoKpisMap = denoKpis.reduce((prev, cur) => {
        prev[cur] = 1;
        return prev;
    }, {});

    const denoResults = yearBasedResults.filter(d => denoKpisMap[d.kpiCode] === 1);
    let numerResult = yearBasedResults.find(d => d.kpiCode === numerKpi);

    if (numerResult?.value == null || !denoResults?.length) return {} as KpiReport;

    // if (numerResult?.value == null) {
    //     return {
    //         ...numerResult,
    //         indicatorTitle: "",
    //         comment: null,
    //         kpiCode: null,
    //         value: null,
    //         unit: "%"
    //     };
    // }

    const denoKpiSumValue = _.sum(
        denoResults?.map(res => getBaseValue(res?.value ?? 0, res?.unit)?.value ?? 0) ?? EMPTY_ARRAY
    );
    if (denoKpiSumValue == null || denoKpiSumValue === 0) {
        return {
            ...numerResult,
            indicatorTitle: "",
            comment: null,
            kpiCode: null,
            value: null,
            unit: "%"
        };
    }

    const value = (getBaseValue(numerResult?.value, numerResult?.unit)?.value * 100) / denoKpiSumValue;
    return {
        ...numerResult,
        indicatorTitle: "",
        comment: null,
        kpiCode: null,
        value,
        unit: "%"
    };
};

// export const getLostSuppliedVolumnPercent = (provider: WaterProvider, kpis: string[][], kpiResults: KpiReport[]) => {
//     const results = kpiResults.filter(d => d?.provider?.tid === provider?.tid);
//     if (!provider || !results?.length) return null;

//     const numerKpi = kpis?.[kpis.length - 1]?.[0];
//     const denoKpis = kpis?.map((kpi, i) => (i === kpis.length - 1 ? null : kpi?.[0]))?.filter(d => d != null) ?? [];
//     const kpiToResults = _.keyBy(results, d => d.kpiCode);

//     const numerKpiValue = kpiToResults?.[numerKpi]?.value;
//     const denoKpiSumValue = _.sum(denoKpis?.map(kpi => kpiToResults?.[kpi]?.value ?? 0) ?? []);

//     if (denoKpiSumValue == null || denoKpiSumValue === 0 || numerKpiValue == null) return null;

//     return (numerKpiValue * 100) / denoKpiSumValue;
// };

// export const fetchFigureLostSuppliedVolumePercentChartData: CategoryChartQueryFn = async ({
//     categoryChart,
//     providers,
//     kpis,
//     category
// }: CategoryChartQueryParam): Promise<CategoryChartData> => {
//     const provider = providers?.[0];
//     const kpi = kpis?.[0];
//     if (!provider || !categoryChart || kpi == null) return null;

//     const unit: Unit = "%";

//     // group by year
//     const groupByYearKpiReportResults = _.groupBy(kpiReportResults, d => d.year);

//     let years = _.orderBy(_.uniq(kpiReportResults?.map(d => d.year) ?? []) ?? [], d => d, "asc");
//     const values =
//         years
//             ?.map(year => {
//                 const reports = groupByYearKpiReportResults[year];
//                 const yearValue = getLostSuppliedVolumnPercent(provider, kpis, reports);
//                 const valueStatus =
//                     yearValue != null ? null : reports?.find(d => d?.provider?.tid === provider?.tid)?.valueStatus;

//                 return {
//                     year,
//                     value: yearValue,
//                     valueStatus
//                 };
//             })
//             ?.filter(d => d != null) ?? [];
//     years = values.map(d => d.year);

//     const { displayTitle, visType, figureHeader, figureFooter } = categoryChart;

//     const latestYear = years?.[years.length - 1];
//     const latestYearValue = values?.[values.length - 1]?.value;
//     const latestYearValueStatus = values?.[values.length - 1]?.valueStatus;

//     const previousYearValue = values?.[values.length - 2]?.value;

//     if (latestYearValue == null) {
//         const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
//             year: latestYear,
//             value: null,
//             deltaString: null
//         });

//         const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
//             year: latestYear,
//             value: null,
//             deltaString: null
//         });

//         return {
//             unit: unit as Unit,
//             year: latestYear,
//             waterProvider: provider,
//             kpiCode: kpi[0],
//             schemeType: kpi[1],
//             title: displayTitle,
//             footer: null,
//             figure: {
//                 header:
//                     !figureHeader || figureHeader.toString().trim() === ""
//                         ? null
//                         : {
//                               processed: figureHeaderProcessed,
//                               value: figureHeaderProcessed,
//                               format: figureHeaderProcessed
//                           },

//                 footer:
//                     !figureFooter || figureFooter.toString().trim() === ""
//                         ? null
//                         : {
//                               processed: figureFooterProcessed,
//                               value: figureFooterProcessed,
//                               format: figureFooterProcessed
//                           },
//                 value: latestYearValueStatus != null ? latestYearValueStatus : previousYearValue != null ? MD : NA,
//                 decimals: 0
//             },
//             graph: null
//         };
//     }

//     // find delta of values between latest year and previous year
//     const delta = deltaValue(previousYearValue, latestYearValue);

//     const deltaString = figureDeltaString(delta, category);

//     // const fawStyle = `style="color: ${getColor(category?.theme)}"`;
//     // const deltaString = `${
//     //     delta === 0
//     //         ? `<span class='fa-solid fa-right mr-1' ${fawStyle}></span> No change from last year`
//     //         : `${
//     //               delta > 0
//     //                   ? `<span class='fa-solid fa-up mr-1' ${fawStyle}></span>`
//     //                   : delta < 0
//     //                   ? `<span class='fa-solid fa-down mr-1' ${fawStyle}></span>`
//     //                   : ""
//     //           } ${delta}% ${delta > 0 ? "above" : "below"} last year`
//     // }`;

//     // create content for header and footer of the figure
//     const figureHeaderProcessed = _.template(figureHeader?.value ?? "")({
//         year: latestYear,
//         value: latestYearValue,
//         deltaString
//     });

//     const figureFooterProcessed = _.template(figureFooter?.value ?? "")({
//         year: latestYear,
//         value: latestYearValue,
//         deltaString
//     });

//     const ret: FigureSolidDashKpiProvider = {
//         unit: unit as Unit,
//         year: latestYear,
//         waterProvider: provider,
//         kpiCode: kpi[0],
//         schemeType: kpi[1],
//         title: displayTitle,
//         footer: null,
//         figure: !(visType === "figure" || visType === "figureWithSolidDashLine")
//             ? null
//             : {
//                   decimals: roundValue(latestYearValue, unit as Unit).decimals,
//                   header:
//                       !figureHeader || figureHeader.processed.trim() === ""
//                           ? null
//                           : {
//                                 processed: figureHeaderProcessed,
//                                 value: figureHeaderProcessed,
//                                 format: figureHeaderProcessed
//                             },
//                   value: roundValue(latestYearValue, unit as Unit).value,
//                   footer:
//                       !figureFooter || figureFooter.processed.trim() === ""
//                           ? null
//                           : {
//                                 processed: figureFooterProcessed,
//                                 value: figureFooterProcessed,
//                                 format: figureFooterProcessed
//                             }
//               },
//         graph: null
//     };

//     return ret;
// };

export const fetchFigureLostSuppliedVolumePercentChartData: CategoryChartQueryFn = async ({
    metadata,
    categoryChart,
    providers,
    kpis,
    category
}: CategoryChartQueryParam): Promise<FigureSolidDashKpiProvider> => {
    const provider = providers?.[0];

    if (!metadata || !providers || providers?.length === 0 || !categoryChart || !kpis || kpis?.length === 0)
        return null;
    let kpiReportResults = await getKpisForProvidersWithCategoryChart(kpis, [provider], true, categoryChart);

    kpiReportResults = (kpiReportResults ?? []).filter(d => d != null && d.provider != null);

    const rec = getFigureAndSolidDashGraph(
        metadata,
        provider,
        kpiReportResults,
        kpis,
        categoryChart,
        category,
        "%",
        getLostSuppliedVolumnPercent
    );

    // const rec = getFigureAndGraphForOperatingSurplusRatio(kpiReportResults, provider, kpis, categoryChart, category);

    if (!rec) return null;

    const { figure, graph, unit, year } = rec;
    return {
        unit,
        year,
        waterProvider: provider,
        kpiCode: null,
        schemeType: kpis?.[0]?.[1],
        title: categoryChart?.displayTitle,
        footer: null,
        figure,
        graph
    };
};
